const styles = () => ({
  reqText: {
    fontStyle: "italic",
    fontWeight: "bold",
  },
  reqTextRed: {
    color: "#ee0000",
    marginLeft: "5px",
  },
  minFont: {
    fontSize: "9px",
  },
  reducedFont: {
    fontSize: "13px",
  },
  fontSize35: {
    fontSize: "35px",
  },
  contractInfoBorder: {
    border: "1px solid grey",
    outlineStyle: "dashed",
    width: "100%",
    padding: "15px",
  },
  lowercase: {
    textTransform: "lowercase",
    cursor: "pointer",
  },
  fontWeightBold: {
    fontWeight: "bold",
  },
  buttonGroupRightAlign: {
    float: "right",
    maxHeight: "30px",
  },
  templateDwIconButton: {
    padding: 8,
    marginRight: 10,
  },
  restOfReqDocBorder: {
    borderBottom: "1px solid black",
    paddingTop: "5px",
    paddingBottom: "5px",
  },
  firstReqDocBorder: {
    borderTop: "1px solid black",
    borderBottom: "1px solid black",
    paddingTop: "5px",
    paddingBottom: "5px",
  },
  paddingTop: {
    paddingTop: "15px",
  },
  gridItemPadding: {
    padding: "8px 0 !important",
  },
  confirmationFooter: {
    position: "absolute",
    backgroundColor: "white",
    "@media (max-width: 768px)": {
      bottom: "0",
    },
  },
  confirmationFooterBtn: {
    margin: "0 10px 0 10px",
    padding: "4px 8px",
    fontSize: "12px",
  },
  paddingRightLeft10: {
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  confirmationItem: {
    backgroundColor: "green",
    color: "white",
    width: "100%",
    margin: "10px 0",
    padding: "12px 0 !important",
  },
  declinedItem: {
    backgroundColor: "#ba3a3a",
  },
  declinedText: {
    padding: "10px 0",
  },
  divider: {
    height: "15px",
    position: "relative",
    overflow: "hidden",
    width: "100%",
  },
  innerShadow: {
    position: "absolute",
    top: "-1px",
    left: "-10px",
    right: "-10px",
    height: "1px",
    boxShadow: "0 1px 2px rgba(0,0,0,0.22)",
    zIndex: 1,
  },
  arrowDown: {
    position: "absolute",
    zIndex: 2,
    width: "13px",
    height: "13px",
    top: "-6px",
    left: 0,
    right: 0,
    margin: "0 auto",
  },
  arrowDownShadow: {
    width: "13px",
    height: "13px",
    boxShadow: "0px 0px 4px rgba(0,0,0,0.22)",
    transform: "rotate(45deg)",
    background: "#e5e5e5",
  },
  originalsWarning: {
    backgroundColor: "rgb(212 184 71)",
    padding: "5px 20px",
    color: "white",
    display: "flex",
    alignItems: "center",
    borderRadius: "5px",
  },
});

export default styles;
